<script>
export default {
  name: "CoursesCategoryCard",
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    parent_id: {
      type: [Number, String],
      required: false,
      default: null,
    },
  },
}
</script>

<template>
  <button
    class="category-card"
    :style="{ background: color }"
  >
    <div class="category-card__header">
      <img src="@/assets/img/course/logo.svg" alt="logo">
      <img src="@/assets/img/course/link.svg" alt="logo">
    </div>
    <p class="category-card__info">{{ name }}</p>
  </button>
</template>

<style scoped>
.category-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 360px;
  padding: 1.5rem;
  border-radius: 10px; 
}

.category-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.category-card__header img {
  height: 2.5rem;
}

.category-card__info {
width: 100%;
  font-weight: 600;
  font-size: 32px;
  line-height: 1.2;
  text-transform: uppercase;
  color: #fff;
  text-align: left;
}
@media(max-width:786px){
  .category-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 240px;
    height: unset;
  }
  .category-card__info{
    font-size: 20px;
  }
}
</style>